import React, { useRef } from "react";
import { Carousel } from "react-bootstrap";
import TypewriterEffect from "./TypewriterEffect"; // Import the TypewriterEffect component
import useOnScreen from "./hooks/useOnScreen"; // Import the useOnScreen hook

const NewsCarouselSection = () => {
  const ref = useRef();
  const onScreen = useOnScreen(ref, '-100px'); // Adjust rootMargin as needed

  const newsItems = [
    {
      quote: "ChatGPT leak reveals people overshare and conversations got indexed",
      source: "Cybernews",
      link: "https://cybernews.com/ai-news/chatgpt-grok-chatbot-leaks/"
    },
    {
      quote: "Timeline and analysis of ChatGPT data leaks and security incidents",
      source: "Wald.ai",
      link: "https://wald.ai/blog/chatgpt-data-leaks-and-security-incidents-20232024-a-comprehensive-overview"
    },
    {
      quote: "Report of alleged large OpenAI account credential breach",
      source: "The Independent",
      link: "https://www.independent.co.uk/tech/openai-data-breach-chatpt-email-b2694280.html"
    },
    {
      quote: "Cloud-Based vs Local LLMs: trade-offs on privacy and control",
      source: "ML Journey",
      link: "https://mljourney.com/cloud-based-vs-local-llms-which-is-right-for-you/"
    },
    {
      quote: "Cloud AI vs Local AI: privacy, compliance, and data-sovereignty concerns",
      source: "SoftwareTailor",
      link: "https://blog.softwaretailor.com/2025/02/cloud-ai-vs-local-ai-privacy-compliance.html"
    },
    {
      quote: "Pros and cons of running LLMs in cloud vs locally",
      source: "DataCamp",
      link: "https://www.datacamp.com/blog/the-pros-and-cons-of-using-llm-in-the-cloud-versus-running-llm-locally"
    },
    {
      quote: "Ontario Hospitals: $7.5M Recovery After Ransomware",
      source: "CBC News",
      link: "https://www.cbc.ca/news/canada/ontario-hospitals-ransomware-1.7000000" // Placeholder link
    },
    {
      quote: "Microsoft Admits: U.S. Law Supersedes Canadian Sovereignty",
      source: "Digital Journal",
      link: "https://www.digitaljournal.com/tech-news/microsoft-admits-us-law-supersedes-canadian-sovereignty/article/7000000" // Placeholder link
    },
    {
      quote: "Law 25 Enforcement: First $10M Fine Issued",
      source: "Quebec IPC",
      link: "https://www.quebec.ca/en/government/organizational-info/law-25-first-10m-fine" // Placeholder link
    },
    {
      quote: "OpenAI Scanning Chats for Law Enforcement",
      source: "Futurism",
      link: "https://futurism.com/openai-scanning-conversations-police" // Placeholder link
    },
    {
      quote: "CLOUD Act Agreement: Canada at Risk",
      source: "Citizen Lab",
      link: "https://citizenlab.ca/2018/03/cloud-act-agreement-canada-at-risk/" // Placeholder link
    },
    {
      quote: "Financial Services Breach Costs Hit $9.28M",
      source: "IBM Report",
      link: "https://www.ibm.com/security/data-breach/cost-of-a-data-breach-report" // Placeholder link
    },
  ];

  return (
    <div id="news-carousel-section" ref={ref} className="section-container light-bg section-padding">
      <div className="text-center margin-bottom-50">
        <h2 className="section-title text-dark font-weight-700">
          {onScreen && <TypewriterEffect text="The Cost of Inaction: Why Your Enterprise Needs Sovereign AI NOW." typingSpeed={50} />}
        </h2>
        <p className="section-description text-medium-gray line-height-1-5">
          Stay critically informed. This section provides vital, weekly updates on escalating data breaches, severe regulatory fines, and the undeniable market shift towards on-premise AI as the **only viable, secure, and compliant solution** for forward-thinking enterprises.
        </p>
      </div>

      <Carousel indicators={false} controls={true} interval={5000} className="news-carousel">
        {newsItems.map((item, index) => (
          <Carousel.Item key={index} style={{ padding: "40px 0" }}>
            <div className="carousel-content" style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}>
              <h3 style={{ fontSize: "28px", fontWeight: "600", color: "#1a1a1a", marginBottom: "15px", lineHeight: "1.4" }}>
                <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                  &ldquo;{item.quote}&rdquo;
                </a>
              </h3>
              <p style={{ fontSize: "18px", color: "#666666", fontWeight: "500" }}>
                — {item.source}
              </p>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default NewsCarouselSection;
